import React, { useEffect, useState } from "react";
import { fileUrl } from "@/lib/api";

/**
 * Full-page background slideshow. Fixed position behind all content.
 * Cross-fades between slides at the given interval.
 */
export const HeroSlideshow = ({ slides = [], intervalMs = 5500 }) => {
  const [index, setIndex] = useState(0);
  const sorted = [...slides].sort((a, b) => (a.order || 0) - (b.order || 0));

  useEffect(() => {
    if (sorted.length <= 1) return;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % sorted.length);
    }, Math.max(1500, intervalMs));
    return () => clearInterval(t);
  }, [sorted.length, intervalMs]);

  if (sorted.length === 0) return null;

  return (
    <div
      className="fixed inset-0 z-0 pointer-events-none overflow-hidden"
      aria-hidden="true"
      data-testid="hero-slideshow"
    >
      {sorted.map((s, i) => (
        <div
          key={s.path + i}
          className="absolute inset-0 transition-opacity duration-[1600ms] ease-in-out"
          style={{
            opacity: i === index ? 1 : 0,
            backgroundImage: `url(${fileUrl(s.path)})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transform: i === index ? "scale(1.03)" : "scale(1)",
            transition:
              "opacity 1600ms ease-in-out, transform 9000ms ease-out",
          }}
        />
      ))}
      {/* Cream scrim — kept light enough to let imagery breathe, dark enough to keep text legible */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(253,251,247,0.55) 0%, rgba(253,251,247,0.48) 50%, rgba(253,251,247,0.70) 100%)",
        }}
      />
      {/* Soft accent vignette */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(900px 600px at 70% 30%, rgba(197,139,118,0.20), transparent 60%)",
        }}
      />
    </div>
  );
};
